module.exports = __webpack_public_path__ + "img/C03TechCargoExpansion_ua.01e0d1ea.webp";